import { createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "page-wrap p-3" }, [
      _createElementVNode("div", { class: "page-header p-3 mb-3 mt-3" }, [
        _createElementVNode("h3", null, "Добро пожаловать")
      ])
    ], -1)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "page-content mt-3 mb-3" }, null, -1)),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "page-footer" }, null, -1))
  ], 64))
}